var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('i',{class:("" + (_vm.appearance.class) + (_vm.large ? ' fa-2x' : ''))}),_c('div',{class:("ranking-text" + (_vm.large ? ' large' : '')),attrs:{"data-test":_vm.indicator}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }